import React, { useState } from "react";
import ReactInputMask from "react-input-mask";
import {
  InputGroup,
  InputGroupText,
  Label,
  Row,
  Col,
  FormGroup,
  Input,
} from "reactstrap";
import Calendar from "assets/icon/calendar-pms.svg";
import DatePicker from "react-datepicker";
import moment from "moment";
import { Field, Formik } from "formik";

const AddAllergies = ({
  addAllergy,
  setAddAllergy,
  reactionDate,
  setReactiondate,
  reportedDate,
  setReportedDate,
}) => {
  // const [reportedDate, setReportedDate] = useState("");
  const [error, setError] = useState(false);
  const [focusedInput, setFocusedInput] = useState("");

  let hasDatePopupOpen = false;
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handleBlur = () => {
    setFocusedInput("");
  };

  const handleStartDate = (reactionDate) => {
    if (reactionDate !== null) {
      const date = moment(reactionDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setReactiondate(date.toDate());
        // SearchTerms.reactionDate=reactionDate
      }
    } else {
      setReactiondate(null);
      // SearchTerms.reactionDate=null
    }
  };
  const handleStartDateRaw = (e) => {
    var val = e.target.value;
    if (val == "__/__/____" && reportedDate !== null) {
      setReportedDate(null);
      setError(false);
      //SearchTerms.reactionDate = null;
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleStartDate(e.target.value);
      //SearchTerms.reactionDate = val;
    }
  };

  const handleEndDate = (reportedDate) => {
    if (reportedDate !== null) {
      const date = moment(reportedDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setReportedDate(date.toDate());
        // SearchTerms.reactionDate=reactionDate
      }
    } else {
      setReportedDate(null);
      // SearchTerms.reactionDate=null
    }
  };
  const handleEndDateRaw = (e) => {
    var val = e.target.value;
    if (val == "__/__/____" && reportedDate !== null) {
      setReportedDate(null);
      setError(false);
      //SearchTerms.reactionDate = null;
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleEndDate(e.target.value);
      //SearchTerms.reactionDate = val;
    }
  };

  const handleFocus = (inputName) => {
    setFocusedInput(inputName);
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAddAllergy({ ...addAllergy, [name]: value });
  };

  return (
    <div style={{ width: "50vw", paddingLeft: "20px", paddingRight: "12px" }}>
      <Row className="mb-2">
        <Label className="mbb-8 add-clinic">
          <span className="text-danger">*</span> Allergy Name
        </Label>
        <Formik>
          <FormGroup className="controls textarea_info search-flex mb-0">
            <InputGroup>
              <Field
                as="select"
                name="allergyName"
                id="option"
                className="order-detail-input"
                value={addAllergy.allergyName}
                onChange={handleChange}
                // className="form-control"
              >
                <option value="" label="Select Allergy" />
                <option value="option1" label="Drug" />
                <option value="option2" label="Food" />
                <option value="option3" label="Chemical" />
                <option value="option3" label="Environmental allergy" />
              </Field>
            </InputGroup>
          </FormGroup>
        </Formik>
      </Row>

      <Row>
        <Col sm={6} md={6} lg={6} className="required-date ">
          <Label className="add-clinic">Reaction Date</Label>
          <InputGroup onMouseLeave={handleMouseLeave} className="date-14px">
            <DatePicker
              id="reactionDate"
              name="reactionDate"
              selected={reactionDate}
              onChange={(reactionDate) => handleStartDate(reactionDate)}
              onFocus={() => handleFocus("StartDate")}
              onBlur={handleBlur}
              isClearable
              onChangeRaw={handleStartDateRaw}
              dateFormat="MM/dd/yyyy"
              placeholderText="Select"
              autoComplete="off"
              customInput={
                <ReactInputMask mask="99/99/9999" value={reactionDate} />
              }
            />
            <InputGroupText onClick={() => handleDateClick("reactionDate")}>
              <img src={Calendar} alt="" />
            </InputGroupText>
          </InputGroup>
        </Col>
        <Col sm={6} md={6} lg={6} className="required-date ">
          <Label className="add-clinic">Date Identified</Label>
          <InputGroup onMouseLeave={handleMouseLeave} className="date-14px">
            <DatePicker
              id="reportedDate"
              name="reportedDate"
              selected={reportedDate}
              onChange={(reportedDate) => handleEndDate(reportedDate)}
              onFocus={() => handleFocus("reportedDate")}
              onBlur={handleBlur}
              isClearable
              onChangeRaw={handleEndDateRaw}
              dateFormat="MM/dd/yyyy"
              placeholderText="Select"
              autoComplete="off"
              customInput={
                <ReactInputMask mask="99/99/9999" value={reportedDate} />
              }
            />
            <InputGroupText onClick={() => handleDateClick("reportedDate")}>
              <img src={Calendar} alt="" />
            </InputGroupText>
          </InputGroup>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col sm={12} md={6}>
          <Label className="mbb-8 add-clinic ">Type of Reaction</Label>
          <Formik>
            <FormGroup className="controls textarea_info search-flex mb-0">
              <InputGroup>
                {addAllergy.typeofReaction === "other" ? (
                  <Input
                    type="text"
                    placeholder="Enter Allergy"
                    // value={medicalCondition.diagnosed}
                    // name="diagnosed"
                    // onChange={handleChange}
                  />
                ) : (
                  <Field
                    as="select"
                    name="typeofReaction"
                    id="option"
                    className="order-detail-input"
                    value={addAllergy.typeofReaction}
                    onChange={handleChange}
                    // className="form-control"
                  >
                    <option value="" label="Select Reaction" />
                    <option value="anaphylaxis" label="Anaphylaxis" />
                    <option value="rash" label="Rash" />
                    <option value="asthma" label="Asthma" />
                    <option value="nausea" label="Nausea" />
                    <option value="anemia" label="Anemia" />
                    <option value="shock" label="Shock" />
                    <option value="other" label="Other" />
                  </Field>
                )}
              </InputGroup>
            </FormGroup>
          </Formik>
        </Col>
        <Col sm={12} md={6}>
          <Label className="mbb-8 add-clinic">Other Reaction</Label>
          <Formik>
            <FormGroup className="controls textarea_info search-flex mb-0">
              <InputGroup>
                <Input
                  name="allergyName"
                  className="order-detail-input"
                  value=""
                  onChange={handleChange}
                  placeholder="Enter"
                ></Input>
              </InputGroup>
            </FormGroup>
          </Formik>
        </Col>
      </Row>
      <Row className="mt-2">
          <Label className="mbb-8 add-clinic">Information Source</Label>
          <Formik>
            <FormGroup className="controls textarea_info search-flex mb-0">
              <InputGroup>
                <Input
                  name="allergyName"
                  className="order-detail-input"
                  value=""
                  onChange={handleChange}
                  placeholder="Describe the source of allergy Information"
                ></Input>
              </InputGroup>
            </FormGroup>
          </Formik>
      </Row>
    </div>
  );
};

export default AddAllergies;
